(() => {
  const formatters = new Map();

  function moneyFormatter(node) {
    const currency = node.dataset.currency;
    const locale = node.dataset.locale || document.documentElement.lang || 'en';
    const key = `${locale}:${currency}`;
    if (!formatters.has(key)) {
      formatters.set(key, new Intl.NumberFormat(locale, { style: 'currency', currency }));
    }
    return formatters.get(key);
  }

  function thresholdFor(node) {
    const base = Number(node.dataset.baseThreshold);
    const currency = node.dataset.currency;
    const baseCurrency = node.dataset.baseCurrency;
    let rate = 1;
    if (currency !== baseCurrency) {
      const nativeCurrency = window.Shopify && window.Shopify.currency;
      if (!nativeCurrency || nativeCurrency.active !== currency) return null;
      rate = Number(nativeCurrency.rate);
    }
    if (!Number.isFinite(base) || base <= 0 || !Number.isFinite(rate) || rate <= 0) return null;
    const digits = moneyFormatter(node).resolvedOptions().maximumFractionDigits;
    const quantum = digits === 0 ? 100 : 1;
    return Math.ceil((base * rate) / quantum) * quantum;
  }

  function render() {
    document.querySelectorAll('[data-sv-shipping-offer]').forEach(node => {
      try {
        const threshold = thresholdFor(node);
        if (threshold === null) return;
        const amount = moneyFormatter(node).format(threshold / 100);
        node.textContent = node.dataset.offerTemplate.replace('__amount__', amount);
      } catch (_) {}
    });

    document.querySelectorAll('[data-sv-shipping-progress]').forEach(node => {
      if (node.dataset.eligible !== 'true') return;
      try {
        const threshold = thresholdFor(node);
        const total = Number(node.dataset.total);
        if (threshold === null || !Number.isFinite(total) || total < 0) return;
        const remaining = Math.max(0, threshold - total);
        const progress = Math.max(0, Math.min(100, (total / threshold) * 100));
        const message = remaining === 0
          ? node.dataset.reachedText
          : node.dataset.remainingTemplate.replace('__amount__', moneyFormatter(node).format(remaining / 100));
        if (node.dataset.summary === 'true') {
          node.textContent = remaining === 0 ? node.dataset.freeText : node.dataset.pendingText;
          return;
        }
        const text = node.querySelector('[data-sv-shipping-message]');
        const track = node.querySelector('[data-sv-shipping-track]');
        const fill = node.querySelector('[data-sv-shipping-fill]');
        if (text) {
          text.textContent = message;
          text.classList.toggle('svh-fsbar__txt--win', remaining === 0);
        }
        if (fill) fill.style.width = `${progress}%`;
        if (track) {
          track.hidden = false;
          track.setAttribute('aria-valuenow', String(Math.round(progress)));
          track.setAttribute('aria-valuetext', message);
        }
      } catch (_) {}
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render, { once: true });
  else render();
  document.addEventListener('shopify:section:load', render);
  window.addEventListener('pageshow', render);
})();
